<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Session Expired</h5>
        </div>
        <div class="modal-body">
          <slot name="body">
            <p>Your session has expired.</p>
            <p>
              Please click
              <span class="login-link" @click="loginAfterSessionExpiry"
                >here</span
              >
              to log in again and continue using DASH.
            </p>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
  name: 'SessionExpiredModal',
  methods: {
    ...mapActions('authStore', ['authenticateOidc']),
    ...mapMutations(['setIsShowSessionExpiredModal']),
    loginAfterSessionExpiry() {
      this.setIsShowSessionExpiredModal(false);

      sessionStorage.setItem(
        'close_session_expired_modal_at',
        new Date().getTime()
      );

      this.authenticateOidc();
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  background-color: rgba($color: #000000, $alpha: 0.6);
}
.modal-dialog {
  margin: auto;
  max-width: 80%;
}
.modal-body {
  padding: 2rem 1rem;
}
.login-link {
  color: $apnic-blue;
  text-decoration: underline;
  cursor: pointer;
}
</style>
